// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgLink24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.27273 6.25C9.68694 6.25 10.0227 6.58579 10.0227 7C10.0227 7.41421 9.68694 7.75 9.27273 7.75H6.54545C4.44928 7.75 2.75 9.44928 2.75 11.5455C2.75 12.5521 3.14988 13.5175 3.86166 14.2292C4.57345 14.941 5.53884 15.3409 6.54545 15.3409H9.27273C9.68694 15.3409 10.0227 15.6767 10.0227 16.0909C10.0227 16.5051 9.68694 16.8409 9.27273 16.8409H6.54545C5.14101 16.8409 3.79409 16.283 2.801 15.2899C1.80791 14.2968 1.25 12.9499 1.25 11.5455C1.25 8.62086 3.62086 6.25 6.54545 6.25H9.27273ZM17.4545 6.25C18.859 6.25 20.2059 6.80791 21.199 7.801C22.1921 8.79409 22.75 10.141 22.75 11.5455C22.75 14.4701 20.3791 16.8409 17.4545 16.8409H14.7273C14.3131 16.8409 13.9773 16.5051 13.9773 16.0909C13.9773 15.6767 14.3131 15.3409 14.7273 15.3409H17.4545C19.5507 15.3409 21.25 13.6416 21.25 11.5455C21.25 10.5388 20.8501 9.57345 20.1383 8.86166C19.4266 8.14988 18.4612 7.75 17.4545 7.75H14.7273C14.3131 7.75 13.9773 7.41421 13.9773 7C13.9773 6.58579 14.3131 6.25 14.7273 6.25H17.4545ZM16.3864 11.5455C16.3864 11.1312 16.0506 10.7955 15.6364 10.7955H8.36364C7.94942 10.7955 7.61364 11.1312 7.61364 11.5455C7.61364 11.9597 7.94942 12.2955 8.36364 12.2955H15.6364C16.0506 12.2955 16.3864 11.9597 16.3864 11.5455Z"
			/>
		</Svg>
	);
});
SvgLink24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgLink24;
